import {
  ProposalGetPayloadInterface,
  ProposalGetResponseInterface,
  NotificationProposalGetResponseInterface,
  LatestNotificationProposalInterface,
  ProposalPendingInterface,
  ProposalGetTextConfirmProposalInterfaceInterface,
  ProposalConfirmedResponseInterface,
  StatusConfirmType,
} from '@interface/proposals';
import { PER_PAGE } from '@constants';
import apiService from './config';

let controllerGetProposals;

export function getProposals({
  page = 1,
}: ProposalGetPayloadInterface): Promise<ProposalGetResponseInterface> {
  const params = {
    page,
    orderBy: 'created_at',
    perPage: PER_PAGE,
  };
  if (controllerGetProposals) {
    controllerGetProposals.abort();
  }

  controllerGetProposals = new AbortController();
  const { signal } = controllerGetProposals;

  return apiService
    .get<ProposalGetResponseInterface>(`proposals/`, {
      params,
      signal,
    })
    .then((res) => res) as Promise<ProposalGetResponseInterface>;
}

export const getLatestNotificationProposal = (): Promise<
  NotificationProposalGetResponseInterface['data']
> => {
  const uri = '/proposals/latest-notifications?limit=1';

  return apiService
    .get<NotificationProposalGetResponseInterface['data']>(uri)
    .then((response) => response.data);
};

export const proposalNotificationRead = (
  id: LatestNotificationProposalInterface['id'],
) => {
  const uri = `proposals/${id}/notification-read`;
  return apiService.patch(uri);
};

export const proposalConfirm = (
  id: ProposalPendingInterface['id'],
  status: StatusConfirmType,
): Promise<ProposalConfirmedResponseInterface['data']> => {
  const uri = `proposals/${id}/status/${status}`;

  return apiService.patch(uri).then((response) => response.data);
};

export const getTextsConfirmProposal = (
  id: string,
  isReject?: boolean,
): Promise<ProposalGetTextConfirmProposalInterfaceInterface> => {
  const uri = `proposals/${id}/pre-confirm`;
  const params: { reject?: boolean } = {};

  if (isReject) {
    params.reject = true;
  }

  return apiService.get(uri, { params });
};

export const getProposalByID = (
  id: string,
): Promise<ProposalPendingInterface> => {
  return apiService
    .get<ProposalPendingInterface>(`proposals/${id}`)
    .then((response) => {
      if (response.data) return response.data;
      throw new Error('Sem dados');
    });
};
